import { Injectable } from '@angular/core';
import { ClientAddress, Contractor, SalesDocumentClient } from '@icc/b2b/shared';

@Injectable({
    providedIn: 'root',
})
export class ClientService {

    static convertToDocumentClient(contractor: Contractor, addresses?: {
        id: number;
        deliveryId: number;
        delivery: ClientAddress;
    }, existingClient?: SalesDocumentClient): SalesDocumentClient {

        let invoiceId = null;
        let invoice = null;

        if(existingClient?.invoice){
            invoiceId = existingClient?.invoice?.id ?? existingClient?.invoiceId;
            invoice = existingClient?.invoice;
        }else if(contractor?.registry){
            invoiceId = contractor?.registry?.id;
            invoice = contractor.registry;
        }else if(contractor?.delivery){
            invoiceId = contractor?.delivery?.id;
            invoice = contractor.delivery;
        }

        return {
            id: contractor.id,
            extId: contractor?.extId ?? null,
            isCompany: contractor.isCompany,
            firstName: contractor.person?.firstName,
            lastName: contractor.person?.lastName,
            reference: contractor.reference || '',
            email: contractor.email,
            officeEmail: contractor.officeEmail,
            registryEmail: contractor.registryEmail,
            deliveryEmail: contractor.deliveryEmail,
            billingDeliveryEmail: contractor.billingDeliveryEmail,
            contactPersonEmail: contractor.person?.email ?? null,
            phoneNumber: contractor?.phoneNumber,
            officePhone: contractor?.officePhone,
            registryPhone: contractor?.registryPhone,
            deliveryPhone: contractor?.deliveryPhone,
            billingDeliveryPhone: contractor?.billingDeliveryPhone,
            contactPersonPhone: contractor.person?.phoneNumber ?? null,
            companyName: contractor.company?.name,
            companyVatNr: contractor.company?.vatNr,
            companyVatNrEu: contractor.company?.vatNrEu,
            deliveryId: addresses?.deliveryId ?? contractor.delivery?.id,
            delivery: addresses?.delivery ?? contractor.delivery,
            billingDelivery: existingClient?.billingDelivery ?? contractor.contact ?? null,
            billingDeliveryId: existingClient?.billingDeliveryId ?? contractor.contact?.id,
            invoiceFromDelivery: (addresses?.deliveryId ?? (addresses?.delivery ?? contractor.delivery)?.id) === invoice?.id ?? true,
            invoiceId,
            invoice,
            otherContact: existingClient?.otherContact || ((addresses?.deliveryId ?? contractor.delivery?.id) !== (existingClient?.billingDeliveryId ?? contractor.contact?.id)),
            version: 1,
        };
    }

    static convertSellerToDocumentClient(seller, contractor?: Contractor, existingClient?: SalesDocumentClient): SalesDocumentClient {
        const invoices = seller?.company?.addresses?.filter(address => Array.isArray(address?.contactFunctions) && address?.contactFunctions?.some(el => el === 'registry'));
        let invoice = invoices[0];
        if (existingClient?.invoice) {
            invoice = existingClient?.invoice;
        } else if (contractor?.registry?.id) {
            invoice = invoices.find(el => el.id === contractor.registry.id);
        }
        const invoiceId = invoice?.id ?? null;

        return {
            id: seller.id,
            extId: contractor?.extId ?? null,
            isCompany: true,
            firstName: seller.person?.first_name,
            lastName: seller.person?.last_name,
            reference: seller.person?.reference_name || '',
            email: seller?.company?.emails?.find(el => el.contactFunction === 'contact')?.email ?? null,
            officeEmail: seller?.company?.emails?.find(el => el.contactFunction === 'office')?.email ?? null,
            registryEmail: seller?.company?.emails?.find(el => el.contactFunction === 'registry')?.email ?? null,
            deliveryEmail: seller?.company?.emails?.find(el => el.contactFunction === 'delivery')?.email ?? null,
            billingDeliveryEmail: seller?.company?.emails?.find(el => el.contactFunction === 'billing_delivery')?.email ?? null,
            contactPersonEmail: seller?.person?.email,
            phoneNumber: seller?.company?.phoneNumbers?.find(el => el.contactFunction === 'contact')?.phoneNumber ?? null,
            officePhone: seller?.company?.phoneNumbers?.find(el => el.contactFunction === 'office')?.phoneNumber ?? null,
            registryPhone: seller?.company?.phoneNumbers?.find(el => el.contactFunction === 'registry')?.phoneNumber ?? null,
            deliveryPhone: seller?.company?.phoneNumbers?.find(el => el.contactFunction === 'delivery')?.phoneNumber ?? null,
            billingDeliveryPhone: seller?.company?.phoneNumbers?.find(el => el.contactFunction === 'billing_delivery')?.phoneNumber ?? null,
            contactPersonPhone: seller?.person?.phone_number,
            companyName: seller.company?.name,
            companyVatNr: seller.company?.vatNr,
            companyVatNrEu: seller.company?.vatNrEu,
            deliveryId: seller?.delivery?.id ?? null,
            delivery: seller?.delivery ?? invoice,
            billingDelivery: existingClient?.billingDelivery ?? contractor?.contact ?? null,
            billingDeliveryId: existingClient?.billingDeliveryId ?? contractor?.contact?.id ?? null,
            invoiceFromDelivery: !seller?.delivery?.id || seller?.delivery?.id === invoice?.id,
            invoiceId,
            invoice,
            otherContact: ((seller.delivery ?? invoice)?.id !== (existingClient?.billingDeliveryId ?? contractor?.contact?.id)) || false,
            version: 1,
        };
    }
}
